// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker-wrapper,
.react-datepicker__input-container {
  display: block;
}

.react-datepicker {
  font-family: ProximaNova-Regular, sans-serif;
  color: #353535;
  border-radius: 0.25em;
  border: 0.063em solid #ebebeb;
  box-shadow: 0 0.125em 0.25em 0 rgba(36, 66, 99, 0.1);
}

.react-datepicker__header {
  border-bottom: 0.063em solid #e9e9e9;
  background-color: transparent;
  padding-top: 0;
}

.react-datepicker__current-month {
  font-family: ProximaNova-Semibold, sans-serif;
  background-color: #4586d2;
  color: white;
  text-transform: uppercase;
  border-radius: 0.313em;
  line-height: 2.5em;
}

.react-datepicker__month {
  font-size: 0.875em;
  font-family: ProximaNova-Semibold, sans-serif;
}

.react-datepicker__month-container {
  padding: 1em;
}

.react-datepicker__day--selected {
  border-radius: 0.357em;
  background-color: #4586d2;
}

.react-datepicker__day-names {
  text-transform: uppercase;
}

.react-datepicker__navigation {
  top: 2em;
}

.react-datepicker__navigation--previous {
  border-right-color: white;
  left: 1.5em;
}

.react-datepicker__navigation--next {
  border-left-color: white;
  right: 1.5em;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle {
  border-bottom-color: #ffffff;
}

.react-datepicker-popper[data-placement^="bottom"]
  .react-datepicker__triangle::before {
  border-bottom-color: #ebebeb;
}
`, "",{"version":3,"sources":["webpack://./source/components/InputCalendar/style.css"],"names":[],"mappings":"AAAA;;EAEE,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B","sourcesContent":[".react-datepicker-wrapper,\n.react-datepicker__input-container {\n  display: block;\n}\n\n.react-datepicker {\n  font-family: ProximaNova-Regular, sans-serif;\n  color: #353535;\n  border-radius: 0.25em;\n  border: 0.063em solid #ebebeb;\n  box-shadow: 0 0.125em 0.25em 0 rgba(36, 66, 99, 0.1);\n}\n\n.react-datepicker__header {\n  border-bottom: 0.063em solid #e9e9e9;\n  background-color: transparent;\n  padding-top: 0;\n}\n\n.react-datepicker__current-month {\n  font-family: ProximaNova-Semibold, sans-serif;\n  background-color: #4586d2;\n  color: white;\n  text-transform: uppercase;\n  border-radius: 0.313em;\n  line-height: 2.5em;\n}\n\n.react-datepicker__month {\n  font-size: 0.875em;\n  font-family: ProximaNova-Semibold, sans-serif;\n}\n\n.react-datepicker__month-container {\n  padding: 1em;\n}\n\n.react-datepicker__day--selected {\n  border-radius: 0.357em;\n  background-color: #4586d2;\n}\n\n.react-datepicker__day-names {\n  text-transform: uppercase;\n}\n\n.react-datepicker__navigation {\n  top: 2em;\n}\n\n.react-datepicker__navigation--previous {\n  border-right-color: white;\n  left: 1.5em;\n}\n\n.react-datepicker__navigation--next {\n  border-left-color: white;\n  right: 1.5em;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle {\n  border-bottom-color: #ffffff;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"]\n  .react-datepicker__triangle::before {\n  border-bottom-color: #ebebeb;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
